import * as React from 'react';
export var defaultSiteMetadata = {
  title: process.env.SITE_TITLE || '',
  titleTemplate: process.env.SITE_TITLE_TEMPLATE || "%s - " + process.env.SITE_TITLE,
  description: process.env.SITE_DESCRIPTION || '',
  headline: process.env.SITE_HEADLINE || '',
  image: process.env.SITE_IMAGE || '',
  siteUrl: process.env.SITE_URL || '',
  video: process.env.SITE_VIDEO || '',
  type: process.env.SITE_TYPE || 'website',
  twitter: process.env.SITE_TWITTER || '',
  youtube: process.env.SITE_YOUTUBE || '',
  facebook: process.env.SITE_FACEBOOK || '',
  linkedin: process.env.SITE_LINKEDIN || '',
  flickr: process.env.SITE_FLICKR || '',
  tiktok: process.env.SITE_TIKTOK || '',
  instagram: process.env.SITE_INSTAGRAM || '',
  name: process.env.SITE_NAME || '',
  url: process.env.SITE_URL || ''
};
export var SiteMetadataContext = React.createContext(defaultSiteMetadata);
export var SiteMetadataProvider = SiteMetadataContext.Provider;